import { Component, inject } from '@angular/core';
import { LnPagesArmorComponent } from '@components/ln-pages-armor/ln-pages-armor.component';
import { LnArrowBackSvgIconComponent } from '@components/svg-icons/ln-arrow-back-svg-icon/ln-arrow-back-svg-icon.component';
import { MenuActions } from '../../shared/states/menu_actions';
import { ShoppingCarBodyComponent } from '@components/shopping-car-body/shopping-car-body.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-shopping-car',
  imports: [LnPagesArmorComponent, LnArrowBackSvgIconComponent, ShoppingCarBodyComponent, TranslocoPipe],
  templateUrl: './shopping-car.component.html',
  styleUrl: './shopping-car.component.css',
})
export class ShoppingCarComponent {
  private menuActions = inject(MenuActions);
  GoHome() {
    this.menuActions.goHome();
  }
}
